import { render } from "./Check.vue?vue&type=template&id=a08dc48c"
import script from "./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/lotties/Check.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a08dc48c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a08dc48c', __exports__)) {
    api.reload('a08dc48c', __exports__)
  }
  
  module.hot.accept("./Check.vue?vue&type=template&id=a08dc48c", () => {
    api.rerender('a08dc48c', render)
  })

}


export default __exports__